import * as React from 'react';

import {BaseRow} from '../../row/base-row/base-row';
import type {BaseRowStatusBadge, ToolbarProps} from '../../row/base-row/base-row';
import type {
    TertiaryActionPropsButton,
    TertiaryActionProps,
} from '../../row/base-row/tertiary-action';
import type {SelectMenuOption} from '../../select-menu/select-menu';

import {AccountCardContents} from './account-card-contents';

type Props = {
    name: string | null | undefined;
    icon: React.ReactNode;
    accountUrl: string | null | undefined;
    description: string | null | undefined;
    location: string | null | undefined;
    role?: string | null | undefined;
    actionMenuOptions?: SelectMenuOption[];
    toolbarProps?: ToolbarProps;
    tertiaryProps?: TertiaryActionProps;
    quaternaryProps?: TertiaryActionPropsButton;
    statusBadges?: BaseRowStatusBadge[];
    phoneNumber?: string | null | undefined;
    phoneExtension?: string | null | undefined;
    // This should always be the ConnectButtonsRow component, it was required to be a prop
    // to allow AccountCard to be a shell due to hooks being called in SmsSidebarButton
    connectButtonsRow?: React.ReactNode;
};

export function AccountCard(props: Props) {
    return (
        <BaseRow
            title={props.name || `Unnamed company`}
            type='accounts'
            customIcon={props.icon}
            actionMenuOptions={props.actionMenuOptions}
            url={props.accountUrl || undefined}
            tertiaryProps={props.tertiaryProps}
            quaternaryProps={props.quaternaryProps}
            toolbarProps={props.toolbarProps}
            statusBadges={props.statusBadges}
        >
            <AccountCardContents
                description={props.description}
                location={props.location}
                phoneNumber={props.phoneNumber}
                phoneExtension={props.phoneExtension}
                connectButtonsRow={props.connectButtonsRow}
                role={props.role}
            />
        </BaseRow>
    );
}
